<script setup lang="ts">
import type { AnchorHTMLAttributes } from 'vue'
import type { RouteLocationNamedRaw } from 'vue-router'

type Color = 'none' | 'brand'

type Props = {
  to?: RouteLocationNamedRaw
  href?: string
  target?: AnchorHTMLAttributes['target']
  color?: Color
}

withDefaults(defineProps<Props>(), {
  color: 'none',
  to: undefined,
  href: undefined,
  target: undefined,
})
</script>

<template>
  <div class="text-link-wrapper">
    <template v-if="to">
      <NuxtLink :to="to" :target="target" class="text-link" :class="{ brand: color === 'brand' }"><slot /></NuxtLink>
    </template>
    <template v-else-if="href">
      <NuxtLink :to="href" :target="target" class="text-link" :class="{ brand: color === 'brand' }" external>
        <slot
      /></NuxtLink>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.text-link-wrapper {
  display: flex;
  align-items: center;
}

.text-link {
  color: var(--semantic-tokens-neutral-weak-text);
  text-decoration: underline;
  font-weight: bold;

  &.brand {
    color: var(--semantic-tokens-brand-strong-text);
    text-decoration: none;
  }

  &:hover {
    opacity: 0.7;
  }
}
</style>
